// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"5eaad758","423":"9a3e13d0","619":"22ff86e8","740":"7cd8dbe1","921":"8e31945b","964":"669ba4c3","995":"31209b19"}[chunkId] + ".css";
};